import { render, staticRenderFns } from "./ReturnGoods1.vue?vue&type=template&id=20c94b1d&"
import script from "./ReturnGoods1.vue?vue&type=script&lang=ts&"
export * from "./ReturnGoods1.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnGoods1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports